import {
  StyledCombobox
} from "./chunk-WHXM4NT3.mjs";
import {
  Tick_default
} from "./chunk-Y36WYHZL.mjs";
import {
  __objRest,
  __spreadValues
} from "./chunk-SGYJX2RX.mjs";

// src/components/combobox/combobox-item.tsx
import React, { forwardRef } from "react";
var ComboboxItem = forwardRef(
  function ComboboxItem2(_a, ref) {
    var _b = _a, { item, children } = _b, rest = __objRest(_b, ["item", "children"]);
    return /* @__PURE__ */ React.createElement(StyledCombobox.Item, __spreadValues({ ref, key: item.value, item }, rest), children, /* @__PURE__ */ React.createElement(StyledCombobox.ItemIndicator, null, /* @__PURE__ */ React.createElement(Tick_default, null)));
  }
);

export {
  ComboboxItem
};
